import React, {Component, Fragment} from 'react';
import createCLMultiplierCropsOrderMutation from 'graphql/mutations/orders/create-cl-multiplier-crops-order.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import {Form, Field, LocalitySelect, CheckboxGroup} from 'components/forms';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createCLMultiplierCropsOrderMutation)
export default class CLMultiplierCropsCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Campo Líder Multiplicador' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='cl'
                        userType='multiplier'
                        links={['crops', 'refund', 'kits', 'trialSigns']}
                    />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'locality'},
                                {key: 'crops', initial: []},
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid}) => (
                                <Fragment>
                                    <div className={styles.title}>Selección de Cultivo</div>
                                    <Field label='Localidad'>
                                        <LocalitySelect
                                            {...this.props.getLocalitySelectProps(getFieldProps('locality'))}
                                        />
                                        {renderErrors('locality')}
                                    </Field>
                                    <Field label='Cultivos a multiplicar'>
                                        <CheckboxGroup
                                            options={[
                                                {label: 'Soja', value: 'Soja'},
                                                {label: 'Trigo', value: 'Trigo'},
                                            ]}
                                            {...getFieldProps('crops')}
                                        />
                                        {renderErrors('crops')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                        <p className={styles.reminder}>Recuerde seleccionar la organización correcta antes de enviar el pedido</p>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-multiplier/crops/index.js